import { parseISO } from 'date-fns';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
export function formatGQLDate() {
    var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date();
    return format(date, 'yyyy-MM-dd');
}
export function parseGQLDate(date) {
    return parseISO(date);
}
export function parseGQLTime(time) {
    return parse(time, 'HH:mm', new Date());
}
export function parseGQLDateAndTime(date, time) {
    return parse("".concat(date, " ").concat(time), 'yyyy-MM-dd HH:mm', new Date());
}
export function formatGQLTime(date) {
    return format(date, 'HH:mm');
}
export function parseGQLDateTime(dateTime) {
    return parseISO(dateTime);
}
